import classNames from 'classnames';
import { CloseOutlined } from '@ant-design/icons';
import { AITeacherIcon } from '@/pages/Mock/Svg/AITeacherIcon';
import i18n from '@/locales/init';
import css from './ai-title.module.less';

export const AITitle: React.FC<{ className?: string; onClose?: () => void; }> = ({ className, onClose }) => {
  return <div className={classNames(css.aiTitleWrapper, className)}>
    <AITeacherIcon size={32} />
    <div className={classNames(css.aiTitleText)}>{i18n.t('雨燕老师')}</div>
    <CloseOutlined className={css.close} onClick={onClose} />
  </div>;
};
